import { render, staticRenderFns } from "./SingleConsignmentStockReturnModal.vue?vue&type=template&id=3ab533da&"
import script from "./SingleConsignmentStockReturnModal.vue?vue&type=script&lang=js&"
export * from "./SingleConsignmentStockReturnModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "SingleConsignmentStockReturnModal.vue"
export default component.exports